/**
 * api的入口文件
 * https://whtestwb.hitecloud.cn/charmapi/doc.html#/home
 * https://doc.apipost.net/docs/detail/4810535f00a9000?target_id=479b36346c85000&locale=zh-cn
 */

import login from "./login";
import register from "./register";
import other from "./other";
import post from "./post";
import doctor from "./doctor";
import procedure from "./procedure";
import instrument from "./instrument";
import user from "./user";
import reservation from "./reservation";
import coupon from "./coupon";

export default {
    ...login,
    ...register,
    ...other,
    ...post,
    ...doctor,
    ...procedure,
    ...instrument,
    ...user,
    ...reservation,
    ...coupon,
};
